import "./style.less";
export default function notification() {
    return {
        restrict: "E",
        scope: { type: "@" },
        transclude: true,
        template: require("./template.html"),

        controller: function ($scope) {
            let styles = "";
            switch ($scope.type) {
                case "success":
                    styles = "alert alert-success";
                    break;
                case "warning":
                    styles = "alert alert-warning";
                    break;
                case "info":
                    styles = "alert alert-info";
                    break;
                case "error":
                    styles = "alert alert-danger";
                    break;
                default:
                // code block
            }

            $scope.styles = styles;
        },
    };
}
